import { AthosRecommendProvider } from '../fetchers/recommend'
import { BeaconAnalyticsProvider } from '../hooks/useBeaconAnalytics'

import { CarouselResults } from './CarouselResults'

export function CarouselRecommend({ profile, productId, itemClass }) {
  return (
    <AthosRecommendProvider profile={profile} productId={productId}>
      <BeaconAnalyticsProvider type="recommendations" profile={profile}>
        <CarouselResults className={itemClass} hideControlsOnMobile={true} />
      </BeaconAnalyticsProvider>
    </AthosRecommendProvider>
  )
}
